'use client'
import { PreviewBoutiqueGridBlock } from '@/payload-types'
import RichText from '@onclicks/sharedcomponents/RichText'
import { CMSLink } from '../../CMSLink'
import { useFetchProducts } from '@onclicks/sharedmedusa/hooks/useFetchProducts'
import Card from './Card/Card'
import { bagelFatOne, quicksand } from '@/utilities/fontImport'

const ProductCardsSmallgrid: React.FC<PreviewBoutiqueGridBlock> = (data) => {
  const { title, richText, links, categoryHandle, onlyPromotions } = data
  const { products, loading } = useFetchProducts({
    countryCode: process.env.NEXT_PUBLIC_MEDUSA_REGION ?? 'be',
    categoryHandle,
    limit: 4,
    onlyPromotions: !!onlyPromotions,
  })

  return (
    <section id="products" className="px-6 lg:px-34 py-10">
      {title && (
        <h1 className={`text-primary text-4xl font-bold mb-4 ${bagelFatOne.className}`}>{title}</h1>
      )}
      {richText && (
        <RichText
          data={richText}
          enableGutter={false}
          className={`mb-4 mt-2 text-lg ${quicksand.className}`}
        />
      )}
      <div className="flex flex-col lg:flex-row items-center lg:gap-x-25">
        <div className="grid grid-cols-1 md:grid-cols-4 mx-auto my-8 w-full gap-6">
          {loading
            ? [1, 2, 3, 4].map((i) => (
                <div
                  key={i}
                  className="animate-pulse bg-gray-300 h-48 rounded-2xl mb-5 flex justify-center items-center"
                />
              ))
            : products.map((product, index) => <Card key={index} product={product} />)}
        </div>
      </div>
      <div className=" max-w-2xl lg:shrink-0 lg:text-left">
        {links &&
          links.map((link, index) => <CMSLink key={index} {...link.link} iconClassName="ml-6" />)}
      </div>
    </section>
  )
}

export default ProductCardsSmallgrid
